<template>
  <div>
    <vx-card title-color="primary" class="fill">
      <div>
        <div class="row fill">
          <div class="col-md-4 shadow bg-white rounded overflow-y-scroll tree-panel">
            <div class="w-100" v-show="Object.keys(getRepositories).length">
              <transition
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut"
              >
                <RepositoriesTree
                  v-for="repository in getRepositories" :key="repository.repositorioId"
                  class="item"
                  :repository="repository"
                />
              </transition>
            </div>
            <span v-if="getRepositories.length <= 0">No tienes acceso a ningun repositorio.</span>
          </div>
          <div id="main-panel" class="col-md-8">
            <b-overlay :show="loading">
              <!-- NAVEGADOR DE DIRECTORIOS Y DOCUMENTOS -->
              <MinimalNavigationPanel
                :add-file="addFile"
                :toggle="toggle" :files="files"
                :show-principal-button="showPrincipalButton"
                :max-files="maxFiles"
              />
              <vs-divider/>
              <h4 class="text-primary">Documentos seleccionados</h4>
              <div class="row">
                <div class="col-3 mt-2" v-for="file in files" :key="file.id">
                  <div class="d-flex flex-column align-items-center">
                    <vs-icon icon="description" size="25px" color="primary" />
                    <b class="text-truncate w-100 text-center">{{ file.name }}</b>
                  </div>
                </div>
              </div>
            </b-overlay>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import RepositoriesTree from '@/febos/global/documentManagement/components/RepositoriesTree';
import MinimalNavigationPanel
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/MinimalNavigationPanel';

export default {
  components: {
    RepositoriesTree,
    MinimalNavigationPanel
  },
  data() {
    return {
      detailItem: {},
      toggle: false
    };
  },
  props: {
    showPrincipalButton: {
      type: Boolean,
      default: false
    },
    addFile: {
      type: Function
    },
    removeFile: {
      type: Function
    },
    files: {
      type: Array,
      default: () => []
    },
    maxFiles: {
      type: Number
    }
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getRepositories',
      'getSelectedElement',
      'loading'
    ])
  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    ...mapActions('DocManagement', [
      'loadRepositories',
      'cleanTreeView',
      'setSelectedRepository'
    ]),
    toggleView() {
      console.log('toggle from parent');
      this.toggle = !this.toggle;
    },
  },
  beforeMount() {
    this.cleanTreeView();
  },
  mounted() {
    if (window.location.hash !== '') {
      // TODO: mostrar mensaje de que estamos llendo en busqueda de tu archivo o carpeta
      this.$bvToast.toast(
        'Espera unos segundos mientras vamos hacia tu archivo o carpeta',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 15000
        }
      );
    }
    this.loadRepositories();
  },
  created() {
    this.closeModal();
  }
};
</script>

<style lang="scss" scoped>
@import '~animate.css/animate.compat.css';
.fill {
  height: calc(var(--vh, 1vh) * 100 - 12.5rem);
}
.tree-panel {
  height: calc(var(--vh, 1vh) * 100 - 14.5rem);
}
</style>
